export class VerticalTabs extends DrupalBehavior {
  offset = 1;

  onContent(context) {
    const desktopSize = window.matchMedia('(min-width: 992px)');
    if (desktopSize.matches) {
      const $tabButtonItems = $('.vertical-tabs--button');
      const $tabContentItems = $(
        '.vertical-tabs--desktop .vertical-tabs--content'
      );
      const $closeButtons = $('.vertical-tabs--desktop .close-button');

      this.setUpClickEvents($tabButtonItems, $tabContentItems, $closeButtons);
    }
  }

  setUpClickEvents($tabButtonItems, $tabContentItems, $closeButtons) {
    $tabButtonItems.each((index, buttonItem) => {
      const $buttonItem = $(buttonItem);
      const adjustedIndex = index + this.offset;

      $buttonItem.on('click', (e) => {
        $buttonItem.addClass('active');
        $tabContentItems.eq(adjustedIndex).addClass('active');
        $buttonItem.siblings('.close-button').addClass('active');
        $tabButtonItems.not($buttonItem).removeClass('active');
        $tabContentItems
          .not($tabContentItems.eq(adjustedIndex))
          .removeClass('active');
        $closeButtons.not($closeButtons.eq(index)).removeClass('active');
      });
    });

    $closeButtons.each((index, closeButton) => {
      const $closeButton = $(closeButton);
      const adjustedIndex = index + this.offset;

      $closeButton.on('click', (e) => {
        $closeButton.siblings('.vertical-tabs--button').removeClass('active');
        $tabContentItems.eq(adjustedIndex).removeClass('active');
        $closeButton.removeClass('active');
        $tabContentItems.first().addClass('active');
      });
    });
  }
}
DrupalBehavior.register('rush_theme.components', 'verticalTabs', VerticalTabs);
